module.exports = __webpack_public_path__ + "static/media/background.a8a52893.jpg";